import ReactDOM from 'react-dom/client';
import { StrictMode, useEffect } from 'react';
import { retrieveLaunchParams } from '@/shared/telegram';
import { notifyTelegramReady } from '@/shared/telegram/bootstrap';

import { Root } from '@/app/Root';
import { EnvUnsupported } from '@/app/EnvUnsupported';
import { init } from '@/init.ts';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);
let disposed = false;

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    disposed = true;
    root.unmount();
  });
}

function ReadyApp() {
  useEffect(notifyTelegramReady, []);
  return <Root />;
}

try {
  // Production bundles cannot mock Telegram, even if VITE_E2E_MODE is accidentally enabled.
  if (import.meta.env.DEV || import.meta.env.MODE === 'e2e') {
    await import('./mockEnv.ts');
  }
  const launchParams = retrieveLaunchParams();
  const { tgWebAppPlatform: platform } = launchParams;
  // Configure all application dependencies.
  await init({
    eruda:
      import.meta.env.DEV &&
      new URLSearchParams(window.location.search).get('debug') === 'true' &&
      ['ios', 'android'].includes(platform),
  }).then(async () => {
    if (disposed) return;
    let app = (
      <StrictMode>
        <ReadyApp />
      </StrictMode>
    );
    if (import.meta.env.VITE_REACT_PROFILING === 'true') {
      const { withProfiling } = await import('@/app/profiling');
      app = withProfiling(app);
    }
    if (!disposed) root.render(app);
  });
} catch {
  if (!disposed) root.render(<EnvUnsupported />);
}
